var map = {
	"./image-carousel.de-CH.json": 1359,
	"./image-carousel.de-DE.json": 1360,
	"./image-carousel.en-CA.json": 1361,
	"./image-carousel.en-GB.json": 1362,
	"./image-carousel.en-IN.json": 1363,
	"./image-carousel.en-ME.json": 1364,
	"./image-carousel.en-US.json": 1365,
	"./image-carousel.es-EM.json": 1366,
	"./image-carousel.es-ES.json": 1367,
	"./image-carousel.fr-BE.json": 1368,
	"./image-carousel.fr-CA.json": 1369,
	"./image-carousel.fr-CH.json": 1370,
	"./image-carousel.nl-BE.json": 1371,
	"./image-carousel.nl-NL.json": 1372,
	"./image-carousel.pl-PL.json": 1373,
	"./image-carousel.pt-BR.json": 1374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1358;